import { render, staticRenderFns } from "./ReportGeneralSettingCard.vue?vue&type=template&id=454225c8&scoped=true"
import script from "./ReportGeneralSettingCard.vue?vue&type=script&lang=ts"
export * from "./ReportGeneralSettingCard.vue?vue&type=script&lang=ts"
import style0 from "./ReportGeneralSettingCard.vue?vue&type=style&index=0&id=454225c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454225c8",
  null
  
)

export default component.exports